import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ObjectTable from "./objectTable";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import { BsDownload } from "react-icons/bs";
import { IoMdAddCircleOutline, IoMdRefresh } from "react-icons/io";
import toast from "react-hot-toast";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import notFound from "../../assets/images/common/image-not-found.png";
import { RiVipCrownFill } from "react-icons/ri";
import { TbTable } from "react-icons/tb";
import { BsGrid1X2Fill } from "react-icons/bs";
import "./object.scss";
import {
  ADD_CONSERVATION,
  ADD_OBJECT,
  EDIT_OBJECT,
  CONSERVATION_KANBAN,
  ADMIN_DETAILS,
  LIST_OBJECT,
  BULK_ACCESSION,
  LIST_PHOTOGRAPHY,
  LIST_CONSERVATION,
  EDIT_PHOTOGRAPHY,
  ADMIN_DETAIL,
  OBJECT_PIN,
  HOME_URL,
} from "../../constants/routers";
import {
  exportObjectList,
  objectPinPageList,
  uploadBulkobjectHandler,
} from "../../api/actions/object";
import { FaRegFile } from "react-icons/fa";
import Loader from "../../components/common/Common/Loader";
import { useFormik } from "formik";
import { FiUpload } from "react-icons/fi";
import { TfiExport } from "react-icons/tfi";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import Objectfilter from "./objectfilter";
import { bulksampledownloadhandler } from "../../api/actions/category";
import { GrServers } from "react-icons/gr";
import { checkPermission } from "../../helpers/permissions";
import star from "../../assets/images/category/star.png";
import Nodata from "../../components/common/Common/Nodata";
import { Dropdown } from "antd";
import { SlOptions } from "react-icons/sl";
import { localDataStore } from "../../components/common/Common/localDataStore";
import FilterList from "../../components/common/Common/FilterList";
import { useSaving } from "../../store/SavinContext";
import InfiniteScroll from "react-infinite-scroll-component";
import { FaFileUpload } from "react-icons/fa";
import { MenuSaving } from "../../store/menuContext";
import "../../assets/styles/bulkupload.scss";
import {
  clearModuleState,
  getModuleState,
  saveModuleState,
} from "../../indexdb/scrollFreezeIndex";
import "../../assets/styles/component-styles/dataTable.scss";
import { RxOpenInNewWindow } from "react-icons/rx";
import { GoArrowLeft } from "react-icons/go";
import ObjectPinTable from "./objectPinTable";
import { usedLastScreen } from "../../api/actions/user";
import { redirectBasedOnPermission } from "../../components/common/Common/utils/redirectbasedpermission";

const BlurImage = ({
  openUrl,
  admin = false,
  selectedOption,
  userUsedLastScreen,
  limit,
  sortBy,
  order,
  image,
  page,
  data,
  userData,
  location,
  conservation,
  search,
  selectedContents,
  formik,
  src,
  count,
  blurHash,
  width = 400,
  height = 300,
}) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const navigate = useNavigate();

  const objectListdata = {
    sort_by: sortBy,
    search: search,
    order: order,
    collection_completed: conservation && "True",
    page: page,
    limit: limit,
    museum_id: userData.museum,
    is_information_pending: selectedOption === "catlog" ? true : false,
    conservation_status:
      (selectedOption === "conservation_is_draft" &&
        "in_conditional_assessment") ||
      (selectedOption === "completed" && "in_conservation"),
    collection_is_draft: selectedOption === "Drafts" && true,
    is_iconic:
      selectedOption === "Iconic object"
        ? true
        : false || formik?.values?.is_iconic,
    is_image: formik?.values?.is_image,
    material: formik?.values?.material_id,
    category: formik?.values?.category_id,
    height_max: formik?.values?.height_max,
    height_min: formik?.values?.height_min,
    width_max: formik?.values?.width_max,
    width_min: formik?.values?.width_min,
    depth_max: formik?.values?.depth_max,
    depth_min: formik?.values?.depth_min,
    period_start: formik?.values?.period_start,
    period_end: formik?.values?.period_end,
    room: formik?.values?.room,
    acquisition_method: formik?.values?.acquisition_method,
    created_by: formik?.values?.created_by,
    start_date: formik?.values?.start_date,
    end_date: formik?.values?.end_date,
    is_drive_link: "",
    modified_start_date: formik?.values?.modified_start_date,
    modified_end_date: formik?.values?.modified_end_date,
    tags: formik?.values?.tags,
    conservation_grade: formik?.values?.conservation_grade,
    is_emergency: formik?.values?.is_emergency,
    object_assigned: formik?.values?.object_assigned,
    period: formik?.values?.period,
    primary_category: formik?.values?.primary_category,
    is_pinned: true,
    transit_room: formik?.values?.transit_room,
  };

  return (
    <div>
      {!isLoaded && (
        <div
          style={{
            height: "300px",
            // width: "330px",
            backgroundColor: "lightgray",
            borderRadius: "12px",
            marginBottom: "20px",
            marginTop: "20px",
          }}
        ></div>
      )}
      <img
        className="masonry-image"
        src={src}
        onClick={() => {
          // const listState = {
          //   scrollY: window.scrollY,
          //   selectedPage: page,
          //   selectedData: data, // your currently loaded data
          // };

          localDataStore(search, selectedContents, formik, false, "objectPin");

          navigate(`${openUrl}/${image?.id}`, {
            state: {
              fromPin: true,
              objectListFormik: objectListdata,
            },
          });
        }}
        alt=""
        style={{
          opacity: isLoaded ? 1 : 0,
          transition: "opacity 0.5s ease-in-out",
          display: isLoaded ? "block" : "none",
        }}
        onLoad={() => setIsLoaded(true)}
      />
    </div>
  );
};

const ObjectList = ({
  kanbantableCons = false,
  toggleView,
  conservation = false,
  admin,
}) => {
  const selectProps = { indeterminate: (isIndeterminate) => isIndeterminate };
  const [data, setData] = useState([]);
  const [reachBottom, setReachBottom] = useState(false);
  const [selectedOption, setSelectedOption] = useState("All");
  const [order, setOrder] = useState(conservation || admin ? "asc" : "desc");
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [update, setUpdate] = useState(false);
  const [pending, setPending] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [sortBy, setSortBy] = useState(conservation || admin ? "priority" : "");
  const [showTable, setShowTable] = useState(conservation ? true : false);
  const [showGrid, setShowGrid] = useState(true);
  const [showUploadodal, setShowUploadmodal] = useState(false);
  const [upload, setUpload] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedContents, setSelectedContents] = useState([]);
  const [justSearched, setJustSearched] = useState(false);
  const [showNoSearch, setShowNoSearch] = useState(false);
  const [isRestoring, setIsRestoring] = useState(false);
  const [progress, setProgress] = useState(0);
  const [count, setCount] = useState();
  const [uploadInProgress, setUploadInProgress] = useState(false);
  const [openUrl, setOpenUrl] = useState();
  const [hasMore, setHasMore] = useState(true);
  const [isClearAll, setIsClearAll] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isCollapsed, setIsCollapsed] = useState(
    conservation ? window.innerWidth <= 1249 : window.innerWidth <= 1405
  );
  const [titleSize, setTitleSize] = useState(
    conservation ? window.innerWidth <= 1120 : window.innerWidth <= 1147
  );
  const [isSwal, setIsSwal] = useState({
    show: false,
    id: "",
  });
  const [objectListFormik, setObjectLIstFormik] = useState();
  const location = useLocation();
  const fromPage = sessionStorage.getItem("frompage");
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("user_info"));
  const userUsedLastScreen = userData?.last_used_screen;
  const { isSaving } = useSaving();
  const { menuCollapse } = MenuSaving();
  const hasRestoredFromSession = useRef(false);

  const formik = useFormik({
    initialValues: {
      is_iconic: "",
      hasIconic: false,
      hasNoIconic: false,
      object_name: "",
      is_image: "",
      hasImage: false,
      hasNoImage: false,
      accession_number: "",
      start_date: "",
      end_date: "",
      modified_start_date: "",
      modified_end_date: "",
      selectedUpdateDate: [],
      created_by: "",
      selectedUser: "",
      height_max: "",
      height_min: "",
      width_max: "",
      width_min: "",
      depth_max: "",
      depth_min: "",
      period_start: "",
      period_end: "",
      acquisition_method: "",
      selectedAccuistion: "",
      building: "",
      room: "",
      selectedRoom: "",
      tags: "",
      material_id: "",
      category_id: "",
      selectedDate: "",
      selectedCategory: "",
      primary_category: "",
      selctedSubCategory: [],
      selectedMaterial: [],
      conservation_grade: "",
      is_emergency: false,
      object_assigned: "",
      period: "",
      transit_room: [],
      selectedTransitRoom: [],
    },
    onSubmit: (values) => {
      hasRestoredFromSession.current = false;
      setUpdate(!update);
      setPage(1);
      // setIsOpen(false);
    },
  });

  const getStyle = (option) => {
    return option === selectedOption
      ? {
          width:
            option === "All"
              ? titleSize
                ? (windowWidth <= 1128 && "50px") ||
                  (windowWidth <= 1504 && "78px")
                : "131px"
              : "",
          border: "1px solid transparent",
          backgroundColor: "#20409A",
          color: "#fff",
        } // Apply new styles for the selected element
      : {
          width:
            option === "All"
              ? titleSize
                ? (windowWidth <= 1128 && "50px") ||
                  (windowWidth <= 1504 && "78px")
                : "131px"
              : "",
        };
  };

  const handleOptionClick = (option) => {
    hasRestoredFromSession.current = false;
    setSelectedOption(option);
    setUpdate(!update);
    setPage(1);
  };

  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };

  const refreshHandler = () => {
    hasRestoredFromSession.current = false;
    formik.resetForm();
    setSearch("");
    setPage(1);
    setSelectedOption("All");
    setSelectedContents([]);
    setUpdate(!update);
  };

  const showTableHandler = () => {
    setShowTable(true);
    setShowGrid(false);
  };

  const showGridHandler = () => {
    setShowGrid(true);
    setShowTable(false);
  };

  const uploadFormik = useFormik({
    initialValues: {
      museum_id: userData.museum,
      file: "",
    },
  });

  const convertBase64 = (resume) => {
    return new Promise((resolve, reject) => {
      if (!(resume instanceof Blob)) {
        reject(new Error("Invalid parameter: Expected a Blob."));
        return;
      }
      const fileReader = new FileReader();
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
      fileReader.readAsDataURL(resume);
    });
  };

  const handleClick = () => {
    document.querySelector(".reference-file")?.click();
  };

  const showHandler = () => {
    setShowUploadmodal(true);
  };

  const hideHandler = () => {
    setShowUploadmodal(false);
  };

  const handlefileChange = (e) => {
    convertBase64(e.target.files[0])
      .then((resp) => {
        uploadFormik.setValues({
          ...uploadFormik.values,
          file: resp,
        });
        setUpload(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSampleDownload = () => {
    bulksampledownloadhandler({ page: 1, file_type: "museum_object" })(
      (response) => {
        if (response?.status) {
          toast.success("Download completed successfully!");
          setShowUploadmodal(false);

          let url = response?.data?.file;
          const fileName = "Object sample CSV.csv";

          if (url) {
            url = url.replace(/^http:\/\//i, "https://");

            if (url.startsWith("blob:")) {
              fetch(url)
                .then((res) => res.blob())
                .then((blob) => {
                  const objectURL = URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.style.display = "none";
                  a.href = objectURL;
                  a.setAttribute("download", fileName);
                  document.body.appendChild(a);
                  a.click();
                  URL.revokeObjectURL(objectURL);
                  document.body.removeChild(a);
                })
                .catch(() => toast.error("Failed to fetch file"));
            } else {
              fetch(url)
                .then((res) => res.blob())
                .then((blob) => {
                  const objectURL = URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.style.display = "none";
                  a.href = objectURL;
                  a.setAttribute("download", fileName);
                  document.body.appendChild(a);
                  a.click();
                  URL.revokeObjectURL(objectURL);
                  document.body.removeChild(a);
                })
                .catch(() => {
                  const a = document.createElement("a");
                  a.style.display = "none";
                  a.href = url;
                  a.setAttribute("download", fileName);
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                });
            }
          } else {
            toast.error("No file URL provided for download!");
          }
        } else {
          toast.error("File download failed!");
        }
      }
    );
  };

  const refetchOnScroll = (type) => {
    if (!isSaving.collection) {
      if (type === "next") {
        setPage(page + 1);
      }
      objectPinPageList({
        sort_by: sortBy,
        search: search,
        order: order,
        page: type === "next" ? page + 1 : page,
        limit: limit,
        museum_id: userData.museum,
        collection_completed: conservation && "True",
        is_information_pending: selectedOption === "catlog" ? true : false,
        conservation_status:
          (selectedOption === "conservation_is_draft" &&
            "in_conditional_assessment") ||
          (selectedOption === "completed" && "in_conservation"),
        collection_is_draft: selectedOption === "Drafts" && true,
        is_iconic:
          selectedOption === "Iconic object"
            ? true
            : false || formik?.values?.is_iconic,
        is_image: formik?.values?.is_image,
        material: formik?.values?.material_id,
        category: formik?.values?.category_id,
        height_max: formik?.values?.height_max,
        height_min: formik?.values?.height_min,
        width_max: formik?.values?.width_max,
        width_min: formik?.values?.width_min,
        depth_max: formik?.values?.depth_max,
        depth_min: formik?.values?.depth_min,
        period_start: formik?.values?.period_start,
        period_end: formik?.values?.period_end,
        room: formik?.values?.room,
        acquisition_method: formik?.values?.acquisition_method,
        created_by: formik?.values?.created_by,
        start_date: formik?.values?.start_date,
        end_date: formik?.values?.end_date,
        is_drive_link: "",
        modified_start_date: formik?.values?.modified_start_date,
        modified_end_date: formik?.values?.modified_end_date,
        tags: formik?.values?.tags,
        conservation_grade: formik?.values?.conservation_grade,
        is_emergency: formik?.values?.is_emergency,
        object_assigned: formik?.values?.object_assigned,
        period: formik?.values?.period,
        primary_category: formik?.values?.primary_category,
        is_pinned: true,
        transit_room: formik?.values?.transit_room,
      })((response) => {
        if (response?.status) {
          setReachBottom(false);
          setPending(false);

          const updatedData = response?.data?.results?.map((conditionItem) => ({
            ...conditionItem,
            is_edit_condition: false,
          }));

          const totalCount = response?.data?.count;

          setTotalRows(totalCount);

          setData((prev) => {
            const allData = [...prev, ...updatedData];
            setTotalRows(totalCount);

            if (allData.length >= totalCount) {
              setHasMore(false);
              setReachBottom(true);
            } else {
              setHasMore(true);
              setReachBottom(false);
            }

            return allData;
          });
        }
      });
    }
  };

  const searchHandler = (e) => {
    hasRestoredFromSession.current = false;
    setPage(1);
    const searchValue = e?.target?.value.trimStart();
    searchValue === "" ? setShowNoSearch(false) : setShowNoSearch(true);
    setSearch(searchValue);
    setUpdate(!update);

    setJustSearched(true);
  };

  let isExporting = false;

  // useEffect(() => {
  //   const handleResize = () => {
  //     const width = window.innerWidth;

  //     if (!conservation) {
  //       if (menuCollapse) {
  //         setIsCollapsed(width <= 1700);
  //       } else {
  //         setIsCollapsed(width <= 1405);
  //       }
  //     } else {
  //       if (menuCollapse) {
  //         setIsCollapsed(width <= 1332);
  //       } else {
  //         setIsCollapsed(width <= 1249);
  //       }
  //     }

  //     setWindowWidth(width); // optional if you're using windowWidth elsewhere
  //   };

  //   window.addEventListener("resize", handleResize);
  //   handleResize(); // Initial check

  //   return () => window.removeEventListener("resize", handleResize);
  // }, [menuCollapse]);

  useEffect(() => {
    const handleResizeText = () => {
      const width = window.innerWidth;

      if (conservation) {
        setTitleSize(menuCollapse ? width <= 1412 : width <= 1120);
      } else {
        setTitleSize(width <= 1504);
      }
    };

    window.addEventListener("resize", handleResizeText);
    handleResizeText(); // Initial run on mount

    return () => {
      window.removeEventListener("resize", handleResizeText);
    };
  }, [menuCollapse]);

  useEffect(() => {
    if (progress === 100 || progress === 0) {
      setTimeout(() => {
        setUpload(false);
        setUploadInProgress(false);
      }, 300);
    }
  }, [progress]);

  useEffect(() => {
    if (upload === true) {
      setProgress(0);
      setUploadInProgress(true);
      console.log("Starting upload...");
      const progressSimulation = () => {
        setProgress(10);
        setTimeout(() => {
          setProgress(50);
        }, 1000);
        setTimeout(() => {
          setProgress(90);
        }, 1000);
        setTimeout(() => {
          uploadBulkobjectHandler({ values: uploadFormik?.values })(
            (response) => {
              if (response?.status) {
                toast.success("File uploaded successfully!");
                setProgress(100);
                hideHandler();
                setPage(1);
                setUpdate(!update);
              } else {
                toast.error(response?.message);
                setProgress(0);
                const fileInput = document.querySelector(".reference-file");

                if (fileInput) {
                  fileInput.type = "text";
                  fileInput.value = "";
                  fileInput.type = "file";
                }
              }
            }
          );
        }, 2000);
      };
      progressSimulation();
    }
  }, [upload, uploadFormik?.values]);
  // useEffect(() => {
  //   (async () => {
  //     const savedState = await getModuleState(MODULE_KEY);
  //     console.log(savedState, "savedstate");

  //     if (savedState) {
  //       // Set restoration flag FIRST to prevent other effects from triggering
  //       hasRestoredFromSession.current = true;
  //       setIsRestoring(true); // Keep this true until scroll is restored
  //       setSelectedOption(savedState.selectedOption);
  //       setData(savedState.selectedData);
  //       setPage(savedState.selectedPage);
  //       setPending(false);
  //       setCount(savedState.count);
  //       if (savedState.selectedData.length >= savedState.count) {
  //         setHasMore(false);
  //         setReachBottom(true);
  //       } else {
  //         setHasMore(true);
  //         setReachBottom(false);
  //       }
  //       // Wait for data to be rendered before scrolling
  //       await new Promise((resolve) => setTimeout(resolve, 100));

  //       if (savedState?.fromTable) {
  //         const scrollContainer = document.querySelector(".my-data-table");
  //         if (scrollContainer) {
  //           scrollContainer.scrollTop = savedState.scrollY;
  //           console.log("Restored table scroll to:", savedState.scrollY);
  //         }
  //       } else {
  //         window.scrollTo(0, savedState.scrollY);
  //         console.log("Restored window scroll to:", savedState.scrollY);
  //       }

  //       await clearModuleState(MODULE_KEY);

  //       // Set restoration complete AFTER scroll is restored
  //       setIsRestoring(false);
  //     }
  //   })();
  // }, []);

  useEffect(() => {
    // if (hasRestoredFromSession.current || isRestoring) {
    //   return;
    // }
    if (!isSaving.collection) {
      const typingTimer = setTimeout(() => {
        setJustSearched(true);
        setPage(1);
        setHasMore(true);
        setPending(true);
        objectPinPageList({
          sort_by: sortBy,
          search: search,
          order: order,
          collection_completed: conservation && "True",
          page: page,
          limit: limit,
          museum_id: userData.museum,
          is_information_pending: selectedOption === "catlog" ? true : false,
          conservation_status:
            (selectedOption === "conservation_is_draft" &&
              "in_conditional_assessment") ||
            (selectedOption === "completed" && "in_conservation"),
          collection_is_draft: selectedOption === "Drafts" && true,
          is_iconic:
            selectedOption === "Iconic object"
              ? true
              : false || formik?.values?.is_iconic,
          is_image: formik?.values?.is_image,
          material: formik?.values?.material_id,
          category: formik?.values?.category_id,
          height_max: formik?.values?.height_max,
          height_min: formik?.values?.height_min,
          width_max: formik?.values?.width_max,
          width_min: formik?.values?.width_min,
          depth_max: formik?.values?.depth_max,
          depth_min: formik?.values?.depth_min,
          period_start: formik?.values?.period_start,
          period_end: formik?.values?.period_end,
          room: formik?.values?.room,
          acquisition_method: formik?.values?.acquisition_method,
          created_by: formik?.values?.created_by,
          start_date: formik?.values?.start_date,
          end_date: formik?.values?.end_date,
          is_drive_link: "",
          modified_start_date: formik?.values?.modified_start_date,
          modified_end_date: formik?.values?.modified_end_date,
          tags: formik?.values?.tags,
          conservation_grade: formik?.values?.conservation_grade,
          is_emergency: formik?.values?.is_emergency,
          object_assigned: formik?.values?.object_assigned,
          period: formik?.values?.period,
          primary_category: formik?.values?.primary_category,
          is_pinned: true,
          transit_room: formik?.values?.transit_room,
        })((response) => {
          if (response?.status) {
            const responseCount = response?.data?.results?.counts;

            setPending(false);
            setJustSearched(false);
            // if (count?.countChange) {
            //   setCount(response?.data?.count);
            // }

            const updatedData = response?.data?.results?.map(
              (conditionItem) => ({
                ...conditionItem,
                is_edit_condition: false,
              })
            );

            const totalCount = response?.data?.count;
            setCount(totalCount);
            setTotalRows(totalCount);

            setData((prev) => {
              const allData = updatedData;

              if (allData.length >= totalCount) {
                setHasMore(false);
                setReachBottom(true);
              } else {
                setHasMore(true);
                setReachBottom(false);
              }

              return allData;
            });
          }
        });
      }, 300); // Delay execution by 300ms

      return () => {
        clearTimeout(typingTimer); // Clear timeout when dependencies change
      };
    }
  }, [update, isSaving?.collection, isRestoring]);

  useEffect(() => {
    const restoreStateFromStorage = (isData) => {
      if (isData) {
        const isTable = localStorage.getItem("Is_table");
        const typedValue = localStorage.getItem("typed_value");
        const selectedContents = localStorage.getItem("selectedContents");

        const selectedFormik = localStorage.getItem("selectedFormik");

        if (isTable) {
          setShowTable(true);
          setShowGrid(false);
          localStorage.removeItem("Is_table");
        }

        if (typedValue) {
          setSearch(typedValue);
          localStorage.removeItem("typed_value");
        }

        if (selectedContents) {
          setSelectedContents(JSON.parse(selectedContents));
          localStorage.removeItem("selectedContents");
        }

        if (selectedFormik) {
          try {
            const parsed = JSON.parse(selectedFormik);
            if (formik && parsed) {
              formik.setValues(parsed);
              localStorage.removeItem("selectedFormik");
            }
          } catch (e) {
            console.error("Error parsing selectedFormik:", e);
          }
        }

        setUpdate((prev) => !prev);
        setPage(1);
      }
    };

    const clearCommonStorage = () => {
      localStorage.removeItem("selectedFormik");
      localStorage.removeItem("selectedContents");
      localStorage.removeItem("Is_table");
      localStorage.removeItem("typed_value");
      localStorage.removeItem("Is_collection");
      localStorage.removeItem("Is_digital");
      localStorage.removeItem("Is_conservation");
      localStorage.removeItem("Is_admin");
      localStorage.removeItem("Is_digital_kanban");
      localStorage.removeItem("Is_conservation_kanban");
      localStorage.removeItem("Is_globalsearch");
    };

    const pathnameKey = location.pathname.split("/")[2];

    let matched = false;

    if (localStorage.getItem("IsObjectPin") && pathnameKey === OBJECT_PIN) {
      localStorage.removeItem("IsObjectPin");
      restoreStateFromStorage("Is_data");
      matched = true;
    }

    if (!matched) {
      clearCommonStorage();
    }
  }, []);

  useEffect(() => {
    if (selectedContents?.length > 0) {
      setShowNoSearch(true);
    }

    if (search) {
      setShowNoSearch(true);
    }
  }, [selectedContents]);

  // default URL
  useEffect(() => {
    const basePath = `/${
      userData.museum_name
        ? userData?.museum_name?.split(" ").join("_")
        : "Nefos"
    }`;
    const url = redirectBasedOnPermission({
      basePath,
      userData,
      userUsedLastScreen,
      // navigate, // optional
    });
    setOpenUrl(url);
  }, []);
  const objectListFormikData = {
    sort_by: sortBy,
    search: search,
    order: order,
    collection_completed: conservation && "True",
    page: page,
    limit: limit,
    museum_id: userData.museum,
    is_information_pending: selectedOption === "catlog" ? true : false,
    conservation_status:
      (selectedOption === "conservation_is_draft" &&
        "in_conditional_assessment") ||
      (selectedOption === "completed" && "in_conservation"),
    collection_is_draft: selectedOption === "Drafts" && true,
    is_iconic:
      selectedOption === "Iconic object"
        ? true
        : false || formik?.values?.is_iconic,
    is_image: formik?.values?.is_image,
    material: formik?.values?.material_id,
    category: formik?.values?.category_id,
    height_max: formik?.values?.height_max,
    height_min: formik?.values?.height_min,
    width_max: formik?.values?.width_max,
    width_min: formik?.values?.width_min,
    depth_max: formik?.values?.depth_max,
    depth_min: formik?.values?.depth_min,
    period_start: formik?.values?.period_start,
    period_end: formik?.values?.period_end,
    room: formik?.values?.room,
    acquisition_method: formik?.values?.acquisition_method,
    created_by: formik?.values?.created_by,
    start_date: formik?.values?.start_date,
    end_date: formik?.values?.end_date,
    is_drive_link: "",
    modified_start_date: formik?.values?.modified_start_date,
    modified_end_date: formik?.values?.modified_end_date,
    tags: formik?.values?.tags,
    conservation_grade: formik?.values?.conservation_grade,
    is_emergency: formik?.values?.is_emergency,
    object_assigned: formik?.values?.object_assigned,
    period: formik?.values?.period,
    primary_category: formik?.values?.primary_category,
    is_pinned: true,
    transit_room: formik?.values?.transit_room,
  };
  const encodedPinState = btoa(JSON.stringify(objectListFormikData));

  return (
    <>
      <section
        style={{ paddingTop: "50px" }}
        className="dashboard appraisal-management light-wrapper dark-wrapper"
      >
        <Objectfilter
          isClearAll={isClearAll}
          setIsClearAll={setIsClearAll}
          setPage={setPage}
          assign={true}
          condition={conservation && true}
          iconic={true}
          reference={!conservation && true}
          update={update}
          setUpdate={setUpdate}
          selectedContents={selectedContents}
          setSelectedContents={setSelectedContents}
          isOpen={isOpen}
          toggleDrawer={toggleDrawer}
          setIsOpen={setIsOpen}
          formik={formik}
        />
        <div className="category-container mt-2">
          <div
            style={{
              position: !showTable && "sticky",
              zIndex: "1",
              background: "white",
              top: "61px",
              paddingTop: "30px",
              paddingBottom: "20px",
            }}
            className="category-title-row object-title-row"
          >
            <div
              className="list-left"
              style={{
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <div className="add-category-title-row">
                <div className=" title-row-content">
                  <div
                    className="title-icon "
                    onClick={() => {
                      const fromPagePath = fromPage?.split("/");

                      if (fromPage) {
                        if (fromPagePath?.length > 1) {
                          navigate(
                            `/${
                              userData.museum_name
                                ? userData?.museum_name?.split(" ").join("_")
                                : "Nefos"
                            }/${fromPagePath[0]}/${fromPagePath[1]}`
                          );
                        } else {
                          navigate(
                            `/${
                              userData.museum_name
                                ? userData?.museum_name?.split(" ").join("_")
                                : "Nefos"
                            }/${fromPage}`
                          );
                        }
                        sessionStorage.removeItem("frompage");
                      } else {
                        navigate(
                          `/${
                            userData.museum_name
                              ? userData?.museum_name?.split(" ").join("_")
                              : "Nefos"
                          }/${HOME_URL}`
                        );
                      }
                    }}
                  >
                    <GoArrowLeft />
                  </div>
                </div>
              </div>
              <h2
                className={conservation && menuCollapse && "conservation-title"}
              >
                Pinned objects
              </h2>
            </div>

            <div className={`category-filter-wrapper `}>
              <div>
                <Form.Control
                  style={{
                    backgroundColor: "#EFF0F0",
                    borderRadius: "22px",
                  }}
                  placeholder="Search"
                  value={search}
                  onChange={searchHandler}
                />
              </div>
              {!isCollapsed && (
                <div
                  style={{ display: "flex", gap: "10px" }}
                  className="show-option"
                >
                  {showGrid && (
                    <Tooltip title="View table">
                      <div className="filter-icons" onClick={showTableHandler}>
                        <TbTable />
                      </div>
                    </Tooltip>
                  )}
                  {showTable && (
                    <Tooltip title="View grid">
                      <div className="filter-icons" onClick={showGridHandler}>
                        <BsGrid1X2Fill />
                      </div>
                    </Tooltip>
                  )}

                  <Tooltip title="Refresh">
                    <div className="filter-icons" onClick={refreshHandler}>
                      <IoMdRefresh />
                    </div>
                  </Tooltip>
                  <Tooltip title="Filter">
                    <div className="filter-icons" onClick={toggleDrawer}>
                      <TuneRoundedIcon />
                    </div>
                  </Tooltip>
                </div>
              )}
            </div>
          </div>
          {selectedContents?.length > 0 && !showTable ? (
            <div
              className="filter-list-container"
              style={{
                backgroundColor: "white",
                position: "sticky",
                zIndex: "8",
                top: "156px",
                paddingTop: showGrid && "20px",
                paddingBottom: showGrid ? "20px" : "10px",
              }}
            >
              <FilterList
                objectCount={totalRows}
                isClearAll={isClearAll}
                setIsClearAll={setIsClearAll}
                hasRestoredFromSession={hasRestoredFromSession}
                setPage={setPage}
                update={update}
                setUpdate={setUpdate}
                formik={formik}
                setIsOpen={setIsOpen}
                setSelectedContents={setSelectedContents}
                selectedContents={selectedContents}
              />
            </div>
          ) : (
            <FilterList
              objectCount={totalRows}
              isClearAll={isClearAll}
              setIsClearAll={setIsClearAll}
              hasRestoredFromSession={hasRestoredFromSession}
              setPage={setPage}
              update={update}
              setUpdate={setUpdate}
              formik={formik}
              setIsOpen={setIsOpen}
              setSelectedContents={setSelectedContents}
              selectedContents={selectedContents}
            />
          )}
          <div className="dataTable-wrapper location-list">
            {pending ? (
              <Loader admin={admin} />
            ) : (
              <>
                {!pending && data.length === 0 && showGrid && !conservation && (
                  <Nodata globalData={showNoSearch} />
                )}
                <InfiniteScroll
                  dataLength={data?.length}
                  next={() => refetchOnScroll("next")}
                  hasMore={hasMore}
                  endMessage={
                    !conservation &&
                    showGrid &&
                    data?.length > 0 && (
                      <p
                        style={{
                          textAlign: "center",
                          padding: "1rem",
                          color: "gray",
                        }}
                      >
                        <b>You have seen it all</b>
                      </p>
                    )
                  }
                >
                  {!conservation && showGrid && (
                    <ResponsiveMasonry
                      columnsCountBreakPoints={{
                        300: 2,
                        500: 3,
                        700: 4,
                        900: 5,
                      }}
                      className="masonry-box"
                    >
                      <Masonry gutter="15px">
                        {data?.map((image) => (
                          <React.Fragment key={image.id}>
                            <div className="flip-card">
                              <div className="flip-card-inner">
                                <div className="masonry-title-box">
                                  {image?.reference_image ? (
                                    <BlurImage
                                      openUrl={openUrl}
                                      userUsedLastScreen={userUsedLastScreen}
                                      sortBy={sortBy}
                                      order={order}
                                      limit={limit}
                                      count={count}
                                      selectedOption={selectedOption}
                                      data={data}
                                      page={page}
                                      image={image}
                                      selectedContents={selectedContents}
                                      formik={formik}
                                      location={location}
                                      userData={userData}
                                      admin={admin}
                                      conservation={conservation}
                                      search={search}
                                      src={image?.reference_image}
                                    />
                                  ) : (
                                    <img
                                      className="masonry-image"
                                      onClick={() => {
                                        localStorage.setItem("objectPin", true);
                                        localStorage.setItem(
                                          "typed_value",
                                          search
                                        );
                                        localStorage.setItem(
                                          "selectedContents",
                                          JSON.stringify(selectedContents)
                                        );
                                        localStorage.setItem(
                                          "selectedFormik",
                                          JSON.stringify(formik?.values)
                                        );

                                        navigate(`${openUrl}/${image?.id}`, {
                                          state: {
                                            fromPin: true,
                                            objectListFormik:
                                              objectListFormikData,
                                          },
                                        });
                                      }}
                                      src={notFound}
                                      alt="error-image"
                                    />
                                  )}
                                  {checkPermission([
                                    "collection_change_object",
                                    "photogrophy_change_object",
                                    "conservation_change_object",
                                  ]) && (
                                    <Tooltip title="Open object in new tab">
                                      <a
                                        href={`${openUrl}/${image?.id}?state=${encodedPinState}&fromPinOpen=true`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          right: image.iconic_object
                                            ? "42px"
                                            : "10px",
                                        }}
                                        className="masonry-link"
                                      >
                                        <RxOpenInNewWindow />
                                      </a>
                                    </Tooltip>
                                  )}
                                  {image.iconic_object && (
                                    <div className="masonry-key">
                                      <RiVipCrownFill />
                                    </div>
                                  )}
                                  {image.collection_is_draft &&
                                    !(admin || admin === "Admin") && (
                                      <div className="masonry-draft">
                                        <FaRegFile style={{ color: "white" }} />
                                      </div>
                                    )}
                                </div>
                              </div>
                            </div>
                            <div className="masonry-title">
                              <h6>{image.object_name}</h6>
                              <p className="object-id">
                                {image.accession_number}
                              </p>
                            </div>

                            {(image.prime_category_name ||
                              image.category_name) && (
                              <p style={{ display: "flex", gap: "7px" }}>
                                <span
                                  style={{
                                    maxWidth: "248px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {image.prime_category_name}
                                  {image.prime_category_name &&
                                    image.category_name &&
                                    " - "}
                                  {image.category_name}
                                </span>

                                {image?.key_category === "True" && (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <img
                                      style={{ height: "15px" }}
                                      src={star}
                                      alt="key-category"
                                    />
                                  </div>
                                )}
                              </p>
                            )}
                          </React.Fragment>
                        ))}
                      </Masonry>
                    </ResponsiveMasonry>
                  )}
                </InfiniteScroll>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  {hasMore && showGrid && <Spinner animation="border" />}
                </div>
              </>
            )}
            {showTable &&
              (data?.length > 0 ? (
                <ObjectPinTable
                  encodedPinState={encodedPinState}
                  openUrl={openUrl}
                  count={count}
                  pending={pending}
                  fetchObjectList={refetchOnScroll}
                  hasMore={hasMore}
                  setJustSearched={setJustSearched}
                  justSearched={justSearched}
                  setReachBottom={setReachBottom}
                  reachBottom={reachBottom}
                  search={search}
                  selectedContents={selectedContents}
                  formik={formik}
                  order={order}
                  setOrder={setOrder}
                  sortBy={sortBy}
                  setSortBy={setSortBy}
                  admin={admin}
                  conservation={conservation}
                  selectedOption={selectedOption}
                  setSelectedOption={setSelectedOption}
                  showGrid={showGrid}
                  setShowGrid={setShowGrid}
                  showTable={showTable}
                  setShowTable={setShowTable}
                  setData={setData}
                  data={data}
                  page={page}
                  limit={limit}
                  setLimit={setLimit}
                  setPage={setPage}
                  setTotalRows={setTotalRows}
                  totalRows={totalRows}
                  selectedRows={selectedRows}
                  setSelectedRows={setSelectedRows}
                  update={update}
                  setUpdate={setUpdate}
                  selectProps={selectProps}
                  isSwal={isSwal}
                  setIsSwal={setIsSwal}
                />
              ) : (
                !pending && <Nodata globalData={showNoSearch} />
              ))}
          </div>
        </div>
      </section>
      <Modal className="bulk_modal" show={showUploadodal} onHide={hideHandler}>
        <Modal.Header
          className="detail-view-header"
          style={{ height: "2vh" }}
          closeButton
        >
          <Modal.Title style={{ fontWeight: "bold" }}>Bulk upload </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="modal_body">
              <div className="main_div">
                <div className="sample_div">
                  <div onClick={handleSampleDownload}>
                    <div className="outline_div">
                      {" "}
                      {/*onClick={downloadHandler}   */}
                      <BsDownload size={30} color="rgb(25, 30, 135)" />
                      <div className="h2_div4">
                        <h2 style={{ fontSize: "13px" }}>Sample CSV</h2>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="upload_div" onClick={handleClick}>
                  <label htmlFor="file"></label>
                  <div className="outline_div">
                    <TfiExport size={30} color="rgb(25, 30, 135)" />
                    <div className="h2_div2">
                      <h2 style={{ fontSize: "13px" }}>Upload CSV</h2>
                    </div>
                    <input
                      type="file"
                      className="reference-file"
                      style={{ display: "none" }}
                      name={`reference`}
                      onChange={handlefileChange}
                      accept=".xlsx, .xls,.csv"
                      isInvalid={null}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Form>
          {uploadInProgress ? (
            <Box sx={{ width: "100%" }}>
              <LinearProgress variant="determinate" value={progress} />
            </Box>
          ) : (
            ""
          )}
        </Modal.Body>
      </Modal>
      {/* <DeleteSweetAlert handleDelete={handleDelete} isSwal={isSwal} setIsSwal={setIsSwal} /> */}
    </>
  );
};

export default ObjectList;
